export enum MANIFEST_TYPE {
  ACE = 'ACE',
  ACI = 'ACI'
}

export interface TripManifest {
  id: string;
  trip_id: string;
  manifest: Record<string, any>;
  status: string;
  control_number: string;
  manifest_type: MANIFEST_TYPE;
  errors: Record<string, any>;
  created_at: Date;
  updated_at: Date;
}

export enum MANIFEST_STATUS {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED'
}
